import { Component, OnInit } from '@angular/core';
import { BaseCtl } from '../common/base.component';
import { ServiceLocatorService } from '../common/service/service-locator.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css']
})
export class ForgetPasswordComponent extends BaseCtl {

  constructor(public locator: ServiceLocatorService, public route: ActivatedRoute) {
    super(locator.endpoints.AUTH, locator, route);
  }

  ngOnInit() {
  }

  populateForm(form, data) {
    super.populateForm(form, data);
    form.login = data.login;

  }
  
  forgetpassword() {
    var _self = this;
    console.log('Forget Password');
    let url = this.locator.endpoints.getEndpoint(this.locator.endpoints.USER, "forgetPassword");
    this.locator.http.post(url, this.form, function (res, error) 
    {
      if (error) {
        alert(error);
        return;
      }
      _self.form.message = res.result.message;
      console.log('Message Forget Password', _self.form.message);
    });




  }

}
